import vi from './viVN';
import en from './enUS';

export interface Locale{
  vi:any,
  en:any
}
const locale:Locale = { vi, en };

export default locale;